export default __webpack_public_path__ + "static/media/for_way2.310c82dc.png";